import { EMAIL_PATTERN } from '@/constant/validation'

/**
 * 驗證 Email 格式
 * @param email Email 地址
 * @returns 是否有效
 */
export const isEmail = (email: string): boolean => {
  return EMAIL_PATTERN.test(email)
}
